<iframe [src]="params.source | urlSanitizer" [class]="params.cssClass">
</iframe>